
import { Vue, Component } from "vue-property-decorator";
import { orderRecordService } from "@/api/payments/order-record";
import AbpBase from "@/lib/view-base/abpbase";
import { SchoolRankDto } from "@/api/service-proxies";

@Component({})
export default class SchoolPayments extends AbpBase {
  schoolRankDto: SchoolRankDto[] = [];
  isTableLoading = false;
  value1: any = "";

  created() {
    this.fetchData();
  }

  async fetchData() {
    this.isTableLoading = true;
    var result = await orderRecordService.getSchoolRank();

    this.schoolRankDto = result.items;

    this.isTableLoading = false;
  }
}
